import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as i1 from 'primeng/dynamicdialog';
import { DialogService } from 'primeng/dynamicdialog';
import * as i3 from 'primeng/galleria';
import { GalleriaModule } from 'primeng/galleria';
import * as i4 from 'primeng/api';
import * as i5 from 'primeng/dialog';
import { DialogModule } from 'primeng/dialog';
const _c0 = () => ({
  "max-width": "1000px"
});
function ImageViewerComponent_li_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "img", 6);
    i0.ɵɵlistener("click", function ImageViewerComponent_li_2_Template_img_click_1_listener() {
      const i_r2 = i0.ɵɵrestoreView(_r1).index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.showLargeImage(i_r2));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const image_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("src", image_r4.source, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("title", image_r4.title);
  }
}
function ImageViewerComponent_ng_template_5_img_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 8);
  }
  if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("src", item_r5.source, i0.ɵɵsanitizeUrl)("alt", item_r5.title);
  }
}
function ImageViewerComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ImageViewerComponent_ng_template_5_img_0_Template, 1, 2, "img", 7);
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", item_r5 != null);
  }
}
function ImageViewerComponent_ng_template_6_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelement(1, "img", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r6 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", item_r6.thumbnail, i0.ɵɵsanitizeUrl);
  }
}
function ImageViewerComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ImageViewerComponent_ng_template_6_div_0_Template, 2, 1, "div", 9);
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    i0.ɵɵproperty("ngIf", item_r6 != null);
  }
}
function ImageViewerComponent_ng_template_7_span_1_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "a", 16);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("href", ctx_r2.images[ctx_r2.imageIndex] == null ? null : ctx_r2.images[ctx_r2.imageIndex].link, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", (ctx_r2.images[ctx_r2.imageIndex] == null ? null : ctx_r2.images[ctx_r2.imageIndex].linkLabel) || ctx_r2.linkLabel, "");
  }
}
function ImageViewerComponent_ng_template_7_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "br");
    i0.ɵɵtemplate(4, ImageViewerComponent_ng_template_7_span_1_span_4_Template, 3, 2, "span", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("Image ", ctx_r2.imageIndex + 1, "/", ctx_r2.images.length, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.images[ctx_r2.imageIndex] == null ? null : ctx_r2.images[ctx_r2.imageIndex].link);
  }
}
function ImageViewerComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, ImageViewerComponent_ng_template_7_span_1_Template, 5, 3, "span", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.images);
  }
}
class ImageViewerComponent {
  constructor(dialogService) {
    this.dialogService = dialogService;
    // images is an an array configuring the component with the following format:
    // { 
    //		"source": "assets/stationImages/100-1.png", 
    //		"thumbnail": "assets/stationImages/100-1-small.png", 
    //		"title": "Carr St 1",
    //		"link": "https://www.weather.gov/images/fgz/webcam/camera1.jpg?1706143015299",
    //		"linkLabel": "To view the full list of camera images"
    // }
    this.images = [];
    // use imageIndex to manage the galleria component
    // and communicate between the large list of images and the galleria
    this.imageIndex = 0;
    // link and link label
    this.linkLabel = "Click for more information.";
    this.numVisible = "5";
    this.displayLargeImage = false;
    this.responsiveOptions = [{
      breakpoint: '1024px',
      numVisible: 5
    }, {
      breakpoint: '768px',
      numVisible: 3
    }, {
      breakpoint: '560px',
      numVisible: 1
    }];
    console.log(this.images);
  }
  ngOnInit() {
    // this didn't work to allow max usage of window for sizing
    // const max_width = Math.round(window.innerWidth * 0.9);
    // this.styleString = "{'max-width': '" + max_width + "px'}";
  }
  ngAfterViewInit() {}
  // showLargeImage sets the dialog containing the galleria to display to true.  
  // Additionally, the imageIndex, the index of the main galleria viewing area, is set.  However,
  // if the image index is the same as the last time a user wanted to view a larger image, the
  // image shown is the same as the last time but this might be a different stations.  Therefore,
  // the image index is temporarily increased by one, then changed back again in a timeout function.
  showLargeImage(index) {
    console.log(index);
    // if the image index is the same, we have to trick Galleria into thinking it has changed.
    if (this.imageIndex === index) {
      console.log('Adjusting imageIndex');
      this.imageIndex++;
      const self = this;
      setTimeout(function () {
        console.log('In setTimeout function');
        self.imageIndex = index;
        self.displayLargeImage = true;
      }, 100);
    } else {
      // the image index was different so the setTimeout function doesn't need to be utilized
      this.imageIndex = index;
      this.displayLargeImage = true;
    }
    console.log(this.images);
  }
  static {
    this.ɵfac = function ImageViewerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImageViewerComponent)(i0.ɵɵdirectiveInject(i1.DialogService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ImageViewerComponent,
      selectors: [["lib-image-viewer"]],
      inputs: {
        images: "images",
        header: "header"
      },
      features: [i0.ɵɵProvidersFeature([DialogService])],
      decls: 8,
      vars: 10,
      consts: [[4, "ngFor", "ngForOf"], [3, "visibleChange", "header", "visible"], [3, "activeIndexChange", "value", "activeIndex", "responsiveOptions", "numVisible", "showItemNavigators", "containerStyle"], ["pTemplate", "item"], ["pTemplate", "thumbnail"], ["pTemplate", "footer"], [1, "thumbnail", 3, "click", "src", "title"], ["style", "width: 100%; display: block;", 3, "src", "alt", 4, "ngIf"], [2, "width", "100%", "display", "block", 3, "src", "alt"], ["class", "p-grid p-nogutter p-justify-center", 4, "ngIf"], [1, "p-grid", "p-nogutter", "p-justify-center"], [3, "src"], [1, "custom-galleria-footer"], ["class", "title-container", 4, "ngIf"], [1, "title-container"], [4, "ngIf"], ["target", "_blank", 2, "color", "blue", "text-decoration", "underline", 3, "href"]],
      template: function ImageViewerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div")(1, "ul");
          i0.ɵɵtemplate(2, ImageViewerComponent_li_2_Template, 2, 2, "li", 0);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(3, "p-dialog", 1);
          i0.ɵɵtwoWayListener("visibleChange", function ImageViewerComponent_Template_p_dialog_visibleChange_3_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.displayLargeImage, $event) || (ctx.displayLargeImage = $event);
            return $event;
          });
          i0.ɵɵelementStart(4, "p-galleria", 2);
          i0.ɵɵtwoWayListener("activeIndexChange", function ImageViewerComponent_Template_p_galleria_activeIndexChange_4_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.imageIndex, $event) || (ctx.imageIndex = $event);
            return $event;
          });
          i0.ɵɵtemplate(5, ImageViewerComponent_ng_template_5_Template, 1, 1, "ng-template", 3)(6, ImageViewerComponent_ng_template_6_Template, 1, 1, "ng-template", 4)(7, ImageViewerComponent_ng_template_7_Template, 2, 1, "ng-template", 5);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngForOf", ctx.images);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("header", ctx.header);
          i0.ɵɵtwoWayProperty("visible", ctx.displayLargeImage);
          i0.ɵɵadvance();
          i0.ɵɵproperty("value", ctx.images);
          i0.ɵɵtwoWayProperty("activeIndex", ctx.imageIndex);
          i0.ɵɵproperty("responsiveOptions", ctx.responsiveOptions)("numVisible", ctx.numVisible)("showItemNavigators", true)("containerStyle", i0.ɵɵpureFunction0(9, _c0));
        }
      },
      dependencies: [i2.NgForOf, i2.NgIf, i3.Galleria, i4.PrimeTemplate, i5.Dialog],
      styles: ["ul[_ngcontent-%COMP%]{list-style-type:none;margin:0;padding:0}li[_ngcontent-%COMP%]{float:left}.thumbnail[_ngcontent-%COMP%]{height:200px;border:1px solid #ddd;padding:4px}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImageViewerComponent, [{
    type: Component,
    args: [{
      selector: 'lib-image-viewer',
      providers: [DialogService],
      template: "<div>\n    <ul>\n\t\t<li *ngFor=\"let image of images; index as i\">\n            <img src={{image.source}} class=\"thumbnail\" title={{image.title}} (click)=\"showLargeImage(i)\"/>\n        </li>\n    </ul>\n</div>\n\n<p-dialog header={{header}} [(visible)]=\"displayLargeImage\">\n    <p-galleria [value]=\"images\" [(activeIndex)]=\"imageIndex\" [responsiveOptions]=\"responsiveOptions\" [numVisible]=\"numVisible\" [showItemNavigators]=true [containerStyle]=\"{'max-width': '1000px'}\">\n        <ng-template pTemplate=\"item\" let-item>\n            <img *ngIf=\"item!=null\" [src]=\"item.source\" style=\"width: 100%; display: block;\" [alt]=\"item.title\" />\n        </ng-template>\n        <ng-template pTemplate=\"thumbnail\" let-item>\n            <div *ngIf=\"item!=null\" class=\"p-grid p-nogutter p-justify-center\">\n                <img [src]=\"item.thumbnail\" />\n            </div>\n        </ng-template>\n        <!--\n        <ng-template pTemplate=\"caption\" let-item>\n            <h4>\n            <a *ngIf=item.link target=\"_blank\" href={{item.link}} style=\"color: white; text-decoration: underline\" >\n                {{item?.linkLabel || linkLabel }}</a>\n            </h4>\n        </ng-template>\n        -->\n        <ng-template pTemplate=\"footer\" let-item>\n            <div class=\"custom-galleria-footer\">\n                <span *ngIf=\"images\" class=\"title-container\">\n                    <span>Image {{ imageIndex + 1 }}/{{ images.length }} </span>\n                    <br>\n                    <span *ngIf=\"images[imageIndex]?.link\">\n                        <a target=\"_blank\" href={{images[imageIndex]?.link}} style=\"color: blue; text-decoration: underline\" >\n                            {{images[imageIndex]?.linkLabel || linkLabel }}</a>\n                    </span>\n                </span>\n            </div>\n        </ng-template>\n    </p-galleria>\n\n    <!-- \n            <a target=\"_blank\" href={{item.link}} style=\"color: blue; text-decoration: underline\" >\n                {{item?.linkLabel || linkLabel }}</a>\n\n    <a *ngIf=linkURL target=\"_blank\" href={{linkURL}}>{{linkLabel}}</a>\n    -->\n</p-dialog>\n",
      styles: ["ul{list-style-type:none;margin:0;padding:0}li{float:left}.thumbnail{height:200px;border:1px solid #ddd;padding:4px}\n"]
    }]
  }], () => [{
    type: i1.DialogService
  }], {
    images: [{
      type: Input
    }],
    header: [{
      type: Input
    }]
  });
})();
class ImageViewerModule {
  static {
    this.ɵfac = function ImageViewerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ImageViewerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ImageViewerModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [BrowserModule, BrowserAnimationsModule, CommonModule, GalleriaModule, DialogModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImageViewerModule, [{
    type: NgModule,
    args: [{
      declarations: [ImageViewerComponent],
      imports: [BrowserModule, BrowserAnimationsModule, CommonModule, GalleriaModule, DialogModule],
      exports: [ImageViewerComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ImageViewerComponent, ImageViewerModule };
